export var PurchaseInvoiceStatus;
(function (PurchaseInvoiceStatus) {
    PurchaseInvoiceStatus[PurchaseInvoiceStatus["Nieuw"] = 1] = "Nieuw";
    PurchaseInvoiceStatus[PurchaseInvoiceStatus["Te_accorderen"] = 2] = "Te_accorderen";
    PurchaseInvoiceStatus[PurchaseInvoiceStatus["Geaccordeerd"] = 3] = "Geaccordeerd";
    PurchaseInvoiceStatus[PurchaseInvoiceStatus["In_boekhouding"] = 4] = "In_boekhouding";
})(PurchaseInvoiceStatus || (PurchaseInvoiceStatus = {}));
